export default "__VITE_ASSET__BaNYuGXL__"